"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _classnames = _interopRequireDefault(require("classnames"));

var _ramda = require("ramda");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _message = require("../../store/gift/postcard/message/message.selectors");

var _gift = require("../../store/gift/gift.selector");

var _invitationType = require("../../store/gift/invitationType/invitationType.selectors");

var _emailProviders = require("../../constants/emailProviders.constant");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    root: {
      paddingTop: spacing(2),
      background: 'red'
    },
    message: {
      whiteSpace: 'pre-line',
      wordBreak: 'break-word'
    },
    title: {
      textTransform: 'uppercase',
      flexGrow: 1
    },
    avatar: {
      width: 27,
      height: 27,
      marginRight: spacing(1)
    },
    fakeAvatar: {
      backgroundColor: palette.divider
    },
    fakeAvatarIcon: {
      width: 'initial',
      color: palette.common.white,
      fontSize: '1rem',
      height: '1rem'
    },
    sendAs: {
      paddingTop: spacing(3)
    }
  };
});

var GiftMessagePreview = function GiftMessagePreview() {
  var classes = useStyles();
  var message = (0, _reactRedux.useSelector)(_message.getMessageText);
  var emailProvider = (0, _reactRedux.useSelector)(_gift.getGiftEmailProvider);
  var sender = (0, _reactRedux.useSelector)(_gift.getGiftSender);
  var isEmailInvitation = (0, _reactRedux.useSelector)(_invitationType.getIsSelectedEmailInvitationType);
  var id = (0, _ramda.propOr)('', 'id', emailProvider);
  var primaryEmailLabel = (0, _ramda.propOr)('', 'primary_email_label', emailProvider);
  var secondaryEmailLabel = (0, _ramda.propOr)('', 'secondary_email_label', emailProvider);
  var isDefaultProvider = id === _emailProviders.EMAIL_PROVIDERS.DEFAULT;
  var isSecondaryEmailVisible = !isEmailInvitation || isEmailInvitation && !isDefaultProvider;
  var senderAvatar = (0, _ramda.propOr)('', 'avatar', sender);
  var senderName = (0, _ramda.propOr)('', 'full_name', sender);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    pt: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('Body-Regular-Left-Static', classes.message)
  }, message), /*#__PURE__*/_react.default.createElement(_material.Box, {
    pt: 2,
    mt: 3,
    borderTop: 1,
    borderColor: "divider"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('Label-Table-Left-Static', classes.title)
  }, "send as"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, senderAvatar ? /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    src: senderAvatar,
    className: classes.avatar,
    alt: senderName
  }) : /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    alt: senderName,
    className: (0, _classnames.default)(classes.avatar, classes.fakeAvatar)
  }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    icon: "user",
    className: classes.fakeAvatarIcon
  })), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, senderName))), emailProvider && /*#__PURE__*/_react.default.createElement(_material.Box, {
    pt: 2,
    mt: 3,
    borderTop: 1,
    borderColor: "divider"
  }, isEmailInvitation && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('Label-Table-Left-Static', classes.title)
  }, isDefaultProvider ? 'Send Initial email and all follow ups Through' : 'Send Initial email Through'), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, primaryEmailLabel))), isSecondaryEmailVisible && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('Label-Table-Left-Static', classes.title)
  }, "Send follow ups emails Through"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, secondaryEmailLabel)))));
};

var _default = GiftMessagePreview;
exports.default = _default;